import React from 'react'
import * as Styled from './paginator.styled'
import { useTranslation, withTranslation } from 'react-i18next'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import { ArrowButton } from '../../core/arrow-button/arrow-button'
import { useResolution } from 'util/hooks/useResolution'

interface PaginatorUIProps {
  total: number
  onNextClick: () => void
  page: number
  perPage: number
  onPageChange: (page: number) => void
  variant?: 'default' | 'compact'
};

const PaginatorUI: React.FC<PaginatorUIProps> = ({ total, onNextClick, page, perPage, onPageChange, variant = 'default' }) => {
  const { t } = useTranslation()
  const { mobile } = useResolution()

  const pagesNumber = Math.min(
    Math.ceil(total / perPage),
    Math.floor(10000 / perPage)
  )

  return (!(pagesNumber < 2)
    ? <Styled.Wrap>
        <Styled.Pagination $variant={variant}>
          {pagesNumber !== page && !!total && (
            <Styled.ShowMore onClick={() => { onNextClick() }} $variant={variant}>
              <span>{`${t('Показати наступні')} ${perPage}`}</span>
            </Styled.ShowMore>
          )}
          <Styled.Paginator>
            <ArrowButton
              type='white'
              style={{ transform: 'rotate(180deg)' }}
              disabled={page < 2}
              onClick={() => { onPageChange(page - 1) }}
            />
            <Pagination
              siblingCount={mobile ? 0 : 1}
              count={pagesNumber}
              hidePrevButton={true}
              hideNextButton={true}
              variant="outlined"
              page={page}
              onChange={(event, page) => { onPageChange(page) }}
              renderItem={(item) => (
                <PaginationItem
                  // eslint-disable-next-line react/display-name
                  component={(props: any) =>
                    // eslint-disable-next-line react/prop-types
                    <Styled.Item {...props} $active={props['aria-current']}></Styled.Item>
                  }
                  {...item}
                />
              )}
            />
            <ArrowButton
              type='white'
              disabled={page >= pagesNumber}
              onClick={() => { onPageChange(page + 1) }}
            />
          </Styled.Paginator>
        </Styled.Pagination>
      </Styled.Wrap>
    : null
  )
}

export default withTranslation('dzo')(PaginatorUI)
